module.exports = __webpack_public_path__ + "static/images/receive-bg.afd88eb.png";